$(function() {
    let email = $("[name=email]")
    let password = $("[name=password]")
    let remember = $("[name=remember]")
    let previous = $("#previous")
    let next = $("#next")
    let submit = $("[type=submit]")

    email.trigger('focus')

    /**
     * Event listener on next button
     */
    next.on("click", function(e) {
        e.preventDefault()
        email.removeClass("is-invalid")
        password.removeClass("is-invalid")
        if (email.val()) {
            next.addClass("btn-loading")
            $.get("login/next", { email: email.val() })
            .done(function(data) {
                if (data.length > 1) {
                    window.location.href = data
                } else {
                    next.addClass("d-none").removeClass("btn-loading")
                    email.attr("readonly", true)
                    password.parents("div").eq(1).removeClass("d-none")
                    password.trigger('focus')
                    remember.closest("div").removeClass("d-none")
                    submit.removeClass("d-none")
                    previous.removeClass("d-none")
                }
            })
        }
    })

    /**
     * Event listener on previous button
     */
    previous.on("click", function(e) {
        e.preventDefault()
        next.removeClass("d-none")
        email.attr("readonly", false)
        email.trigger('focus')
        password.parents("div").eq(1).addClass("d-none")
        remember.closest("div").addClass("d-none")
        submit.addClass("d-none")
        previous.addClass("d-none")
    })

    /**
     * Block form submit via Enter if some fields are empty or trigger next
     */
    $('form').on('keypress', function(e) {
        if (e.which == 13) {
            if (email.val().length < 1 && password.val().length < 1) return false
            if (email.val().length > 0 && password.val().length < 1) {
                next.trigger("click")
                return false
            }
            if (email.val().length > 0 && password.val().length > 1 && password.parents("div").eq(1).hasClass("d-none")) {
                next.trigger("click")
                return false
            }
        }
    });
})